import styled from '@emotion/styled'

const Handle = styled.div`
  flex: none;
  width: 10px;
  height: 100%;
  &::before {
    content: '';
    border-left: 4px dotted #ccc;
    border-right: 4px dotted #ccc;
    display: block;
    height: 17px;
    margin: 15px 0;
  }

  &:hover::before {
    border-color: #888;
  }
`

export default Handle
